import actionTypes from './actiontypes';
import { AppKeys, newMsg } from '../../core/localization';

export const ActionTypes = actionTypes;
export * from './actiontypes';
export * from './actions';
// export * from "./interfaces";
export * from './model';
export * from './defaults';
export * from './mappings';
export * from './utils';

export enum ConsumptionType {
  Heat = 0,
  VolumeHeat = 1,
  VolumeCold = 2,
  HeatCooling = 3,
  Cooling = 4,
  Energy = 5,
  Electricity = 6,
  Pressure = 7,
  TemperatureHumidity = 8,
  WaterReclaimed=9,
  Unknown = 1000,
}

export const ConsumptionTypeDisplay: { [key: number]: string } = {
  [ConsumptionType.Heat]: AppKeys.Device_Consumption_Heat,
  [ConsumptionType.VolumeHeat]: AppKeys.Device_Consumption_VolumeHeat,
  [ConsumptionType.VolumeCold]: AppKeys.Device_Consumption_VolumeCold,
  [ConsumptionType.HeatCooling]: AppKeys.Device_Consumption_HeatCooling,
  [ConsumptionType.Cooling]: AppKeys.Device_Consumption_Cooling,
  [ConsumptionType.Energy]: AppKeys.Device_Consumption_Energy,
  [ConsumptionType.Electricity]: AppKeys.Device_Consumption_Electricity,
  [ConsumptionType.Pressure]: AppKeys.Device_Consumption_Pressure,
  [ConsumptionType.TemperatureHumidity]:
    AppKeys.Device_Consumption_TemperatureHumidity,
  [ConsumptionType.WaterReclaimed]:
    AppKeys.Device_Consumption_WaterReclaimed,
  [ConsumptionType.Unknown]: AppKeys.Device_Consumption_Unknown,
};

export enum AvailabilityLevels {
  Normal = 0,
  Extended = 1,
}

export const AvailabilityLevelDisplay: { [key: number]: string } = {
  [AvailabilityLevels.Normal]: AppKeys.Device_Availability_Normal,
  [AvailabilityLevels.Extended]: AppKeys.Device_Availability_Extended,
};

export const DeviceTypes = {
  CONCENTRATORS: 2,
  GATEWAYS: 3,
  // FLOWSENSORS: 5,
  METERS: 0,
  REPEATERS: 1,
  VALVES: 4,
};

export const DeviceTypeNames = {
  [DeviceTypes.CONCENTRATORS]: newMsg(AppKeys.Device_Type_Concentrator),
  [DeviceTypes.GATEWAYS]: newMsg(AppKeys.Device_Type_Gateway),
  // [DeviceTypes.FLOWSENSORS]: newMsg(AppKeys.Device_Type_Flowsensor),
  [DeviceTypes.METERS]: newMsg(AppKeys.Device_Type_Meter),
  [DeviceTypes.REPEATERS]: newMsg(AppKeys.Device_Type_Repeater),
  [DeviceTypes.VALVES]: newMsg(AppKeys.Device_Type_Valves),
};
